/**
 * Time Entry Type Constants
 *
 * Complete `time_entry_type` value set (mirrored by codegen `Time_Entry_Type`).
 * Use `z.enum(TIME_ENTRY_TYPE_VALUES)` for tool/form input — never a hand-typed
 * subset (the chat tools previously exposed only billable/non_billable, hiding
 * research/travel). `satisfies readonly Time_Entry_Type[]` breaks `tsc` on drift.
 */

import type { Time_Entry_Type } from "@/src/gql/graphql";

export const TIME_ENTRY_TYPE_VALUES = [
  "billable",
  "non_billable",
  "research",
  "travel",
] as const satisfies readonly Time_Entry_Type[];
